(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compare-models"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // Initialise every instance of the section on the page
    document.querySelectorAll('.compare-models').forEach(function (section) {
      if (section.dataset.cmInit) return;
      section.dataset.cmInit = 'true';

      var track        = section.querySelector('.compare-models__track');
      var cards        = Array.from(section.querySelectorAll('.compare-card'));
      var filterBtns   = Array.from(section.querySelectorAll('.compare-models__filter-btn'));
      var compareInput = section.querySelector('.compare-models__toggle-input');
      var compareLabel = section.querySelector('.compare-models__compare-label');
      var scrollDots   = Array.from(section.querySelectorAll('.compare-models__scroll-dot'));

      if (cards.length === 0) return;

      /* ---------- Helpers ---------- */
      function getSpecs(card) {
        var specEls = card.querySelectorAll('.compare-card__spec');
        var specs = {};
        specEls.forEach(function (el) {
          var key = el.dataset.spec;
          var val = parseFloat(el.dataset.value);
          specs[key] = { el: el, val: isNaN(val) ? 0 : val };
        });
        return specs;
      }

      /* ---------- Best-In-Class ---------- */
      function clearBest() {
        section.querySelectorAll('.compare-card__spec.is-best').forEach(function (el) {
          el.classList.remove('is-best');
        });
        section.querySelectorAll('.compare-card__best-label').forEach(function (el) {
          el.classList.remove('is-visible');
          el.innerHTML = '';
        });
      }

      function computeBestSpecs() {
        clearBest();
        var visibleCards = cards.filter(function (c) { return !c.classList.contains('is-hidden'); });
        if (visibleCards.length < 2) return;

        var allSpecs = {};
        visibleCards.forEach(function (card) {
          var specs = getSpecs(card);
          Object.keys(specs).forEach(function (key) {
            if (!allSpecs[key]) allSpecs[key] = [];
            allSpecs[key].push({ card: card, el: specs[key].el, val: specs[key].val });
          });
        });

        var bestLabels = {
          range: 'Best Range',
          speed: 'Fastest',
          charging: 'Fastest Charging',
          warranty: 'Best Warranty'
        };
        var lowerIsBetter = ['charging'];
        // Track which card already has a label so we don't overwrite
        var labelAssigned = {};

        Object.keys(allSpecs).forEach(function (key) {
          var entries = allSpecs[key];
          if (entries.length < 2) return;

          var best;
          if (lowerIsBetter.indexOf(key) !== -1) {
            best = entries.reduce(function (a, b) { return a.val < b.val ? a : b; });
          } else {
            best = entries.reduce(function (a, b) { return a.val > b.val ? a : b; });
          }

          var others = entries.filter(function (e) { return e !== best; });
          var isTied = others.some(function (e) { return e.val === best.val; });
          if (isTied) return;

          best.el.classList.add('is-best');

          // Only first-won label appears on the card to avoid clutter
          var cardId = cards.indexOf(best.card);
          if (!labelAssigned[cardId] && bestLabels[key]) {
            var label = best.card.querySelector('.compare-card__best-label');
            if (label) {
              label.innerHTML = '<svg viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>' + bestLabels[key];
              label.classList.add('is-visible');
              labelAssigned[cardId] = true;
            }
          }
        });
      }

      /* ---------- Compare Toggle ---------- */
      if (compareInput) {
        compareInput.addEventListener('change', function () {
          section.classList.toggle('is-compare-mode', this.checked);
          if (compareLabel) {
            compareLabel.classList.toggle('is-active-label', this.checked);
          }
          if (this.checked) {
            computeBestSpecs();
          } else {
            clearBest();
          }
        });
      }

      /* ---------- Filter Buttons ---------- */
      // Filter functions: return true to keep the card visible
      var FILTERS = {
        all: function () { return true; },
        city: function (card) {
          // City = balanced range + reasonable price (under ₹90k OR range under 100km)
          var price = parseFloat(card.dataset.price) || 0;
          var range = parseFloat(card.dataset.range) || 0;
          return price <= 95000 || range <= 100;
        },
        range: function (card) {
          // Range = top 50% by range value
          var ranges = cards.map(function (c) { return parseFloat(c.dataset.range) || 0; });
          var max = Math.max.apply(null, ranges);
          return (parseFloat(card.dataset.range) || 0) >= max * 0.7;
        },
        budget: function (card) {
          // Budget = under ₹90k
          return (parseFloat(card.dataset.price) || 0) <= 90000;
        }
      };

      var SORTS = {
        all: null,
        city: function (a, b) {
          var aScore = (parseFloat(a.dataset.range) || 0) / Math.max(parseFloat(a.dataset.price) || 1, 1);
          var bScore = (parseFloat(b.dataset.range) || 0) / Math.max(parseFloat(b.dataset.price) || 1, 1);
          return bScore - aScore;
        },
        range: function (a, b) { return (parseFloat(b.dataset.range) || 0) - (parseFloat(a.dataset.range) || 0); },
        budget: function (a, b) { return (parseFloat(a.dataset.price) || 0) - (parseFloat(b.dataset.price) || 0); }
      };

      filterBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          filterBtns.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');

          var filter = btn.dataset.filter;
          var filterFn = FILTERS[filter] || FILTERS.all;
          var sortFn = SORTS[filter];

          // Animate out
          cards.forEach(function (card) { card.classList.add('is-animating-out'); });

          setTimeout(function () {
            // Apply filter
            cards.forEach(function (card) {
              if (filterFn(card)) {
                card.classList.remove('is-hidden');
              } else {
                card.classList.add('is-hidden');
              }
            });

            // Sort or restore order
            var visible = cards.filter(function (c) { return !c.classList.contains('is-hidden'); });
            if (sortFn) {
              visible.sort(sortFn);
            } else {
              visible.sort(function (a, b) {
                return parseInt(a.dataset.order, 10) - parseInt(b.dataset.order, 10);
              });
            }
            visible.forEach(function (card) { track.appendChild(card); });
            // Move hidden cards to end (so DOM order stays predictable for re-show)
            cards.filter(function (c) { return c.classList.contains('is-hidden'); })
                 .forEach(function (card) { track.appendChild(card); });

            // Animate in visible cards
            cards.forEach(function (card) {
              card.classList.remove('is-animating-out');
              if (!card.classList.contains('is-hidden')) {
                card.classList.add('is-animating-in');
              }
            });

            updateFeaturedCard();

            if (section.classList.contains('is-compare-mode')) {
              computeBestSpecs();
            }

            setTimeout(function () {
              cards.forEach(function (card) { card.classList.remove('is-animating-in'); });
            }, 550);
          }, 380);
        });
      });

      /* ---------- Featured Card ---------- */
      function updateFeaturedCard() {
        var visible = cards.filter(function (c) { return !c.classList.contains('is-hidden'); });
        cards.forEach(function (c) { c.classList.remove('is-featured'); });
        if (visible.length >= 3) {
          visible[1].classList.add('is-featured');
        } else if (visible.length > 0) {
          visible[0].classList.add('is-featured');
        }
      }

      /* ---------- Scroll Dots ---------- */
      if (track && scrollDots.length > 0) {
        var updateDots = function () {
          var firstCard = track.querySelector('.compare-card');
          if (!firstCard) return;
          var cardWidth = firstCard.offsetWidth + 20;
          var idx = Math.round(track.scrollLeft / cardWidth);
          scrollDots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === idx);
          });
        };
        track.addEventListener('scroll', updateDots, { passive: true });
        scrollDots.forEach(function (dot, i) {
          dot.addEventListener('click', function () {
            var firstCard = track.querySelector('.compare-card');
            if (!firstCard) return;
            var cardWidth = firstCard.offsetWidth + 20;
            track.scrollTo({ left: i * cardWidth, behavior: 'smooth' });
          });
        });
      }

      /* ---------- Scroll Reveal ---------- */
      var revealEls = section.querySelectorAll('.sr');
      if ('IntersectionObserver' in window && revealEls.length > 0) {
        var revealObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              revealObs.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });
        revealEls.forEach(function (el) { revealObs.observe(el); });
      } else {
        revealEls.forEach(function (el) { el.classList.add('is-visible'); });
      }

      /* ---------- Animated Counters ---------- */
      function animateCounters() {
        var specValues = section.querySelectorAll('.compare-card__spec-value');
        specValues.forEach(function (el) {
          var target = parseFloat(el.dataset.target);
          if (isNaN(target)) return;
          var small = el.querySelector('small');
          var smallHTML = small ? small.outerHTML : '';
          var hasDecimal = (target % 1 !== 0);
          var duration = 1400;
          var startTime = null;

          function step(now) {
            if (!startTime) startTime = now;
            var progress = Math.min((now - startTime) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            var current = target * eased;
            var formatted = hasDecimal ? current.toFixed(1) : Math.round(current);
            el.innerHTML = formatted + ' ' + smallHTML;
            if (progress < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
      }

      if ('IntersectionObserver' in window) {
        var counterObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              animateCounters();
              counterObs.unobserve(entry.target);
            }
          });
        }, { threshold: 0.3 });
        counterObs.observe(section);
      }

      /* ---------- Particle Background — DISABLED to avoid duplicating
         the global homepage constellation. The canvas element still
         exists in DOM but CSS hides it, and we skip init here. ---------- */

      /* ---------- Initial state ---------- */
      updateFeaturedCard();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('sticky-header-deltic')) return;

    class StickyHeaderDeltic extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.drawer        = this.querySelector('[data-drawer]');
        this.backdrop      = this.querySelector('[data-backdrop]');
        this.hamburger     = this.querySelector('[data-action="toggle-drawer"]');
        this.searchOpenBtn = this.querySelector('[data-action="open-search"]');
        this.searchClose   = this.querySelector('[data-action="close-search"]');
        this.searchOverlay = this.querySelector('[data-search-overlay]');
        this.searchInput   = this.searchOverlay && this.searchOverlay.querySelector('input[type="search"]');

        this.lastScrollY = window.scrollY;
        this.isSticky    = this.classList.contains('dl-hdr--sticky');

        this.bindEvents();

        if (this.isSticky) {
          window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
        }
      }

      bindEvents() {
        // Drawer
        if (this.hamburger && this.drawer) {
          this.hamburger.addEventListener('click', () => this.toggleDrawer());
        }
        if (this.backdrop) {
          this.backdrop.addEventListener('click', () => {
            this.closeDrawer();
            this.closeSearch();
          });
        }

        // Search
        if (this.searchOpenBtn) {
          this.searchOpenBtn.addEventListener('click', () => this.openSearch());
        }
        if (this.searchClose) {
          this.searchClose.addEventListener('click', () => this.closeSearch());
        }

        // Escape key
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.closeDrawer();
            this.closeSearch();
          }
        });
      }

      // ---------- Drawer ----------
      toggleDrawer() {
        const isOpen = this.drawer.classList.contains('is-open');
        if (isOpen) this.closeDrawer();
        else this.openDrawer();
      }

      openDrawer() {
        this.drawer.classList.add('is-open');
        this.backdrop.classList.add('is-visible');
        this.hamburger.classList.add('is-open');
        this.hamburger.setAttribute('aria-expanded', 'true');
        this.drawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('dl-hdr-scroll-lock');
      }

      closeDrawer() {
        this.drawer.classList.remove('is-open');
        if (!this.searchOverlay || !this.searchOverlay.classList.contains('is-open')) {
          this.backdrop.classList.remove('is-visible');
          document.body.classList.remove('dl-hdr-scroll-lock');
        }
        this.hamburger.classList.remove('is-open');
        this.hamburger.setAttribute('aria-expanded', 'false');
        this.drawer.setAttribute('aria-hidden', 'true');
      }

      // ---------- Search ----------
      openSearch() {
        if (!this.searchOverlay) return;
        this.searchOverlay.classList.add('is-open');
        this.backdrop.classList.add('is-visible');
        this.searchOverlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('dl-hdr-scroll-lock');
        // Focus input after animation
        setTimeout(() => this.searchInput && this.searchInput.focus(), 200);
      }

      closeSearch() {
        if (!this.searchOverlay) return;
        this.searchOverlay.classList.remove('is-open');
        if (!this.drawer || !this.drawer.classList.contains('is-open')) {
          this.backdrop.classList.remove('is-visible');
          document.body.classList.remove('dl-hdr-scroll-lock');
        }
        this.searchOverlay.setAttribute('aria-hidden', 'true');
      }

      // ---------- Sticky scroll behavior ----------
      handleScroll() {
        const currentY = window.scrollY;
        const delta = currentY - this.lastScrollY;

        // Add scrolled class when past 20px
        if (currentY > 20) {
          this.classList.add('is-scrolled');
        } else {
          this.classList.remove('is-scrolled');
        }

        // Hide on scroll down past threshold, show on scroll up
        if (currentY > 100) {
          if (delta > 4) {
            this.classList.add('is-hidden');
          } else if (delta < -4) {
            this.classList.remove('is-hidden');
          }
        } else {
          this.classList.remove('is-hidden');
        }

        this.lastScrollY = currentY;
      }
    }

    customElements.define('sticky-header-deltic', StickyHeaderDeltic);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
      
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));     
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);


  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              $('.loading-image').removeClass('loading-image').addClass('loaded-image');
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
